<app-logo-area [breadcrumbs]="breadCrumbs()"></app-logo-area>

<main>
  <app-headline-section [title]="poItemId() + ' Details'"></app-headline-section>

  @if (loading) {
    <section class="cl-section cl-section-regular">
      <div style="height: 10vh"></div>
      <div style="width: 100%; display: flex; align-items: center; justify-content: center;">
        <div class="cl-spinner">Loading Encode Details ...<i class="fas fa-spinner fa-spin"></i></div>
      </div>
    </section>
  }

  @if (poItem(); as poItem) {

    <!-- Action Bar -->
    <section class="cl-section cl-section-regular">
      <div class="container">
        <p class="alert cl-alert-action">
          @if (PO_DESTINATIONS[poItem['po_destination']] != null && PO_DESTINATIONS[poItem['po_destination']].publishable) {
            <a role="button"
               [class.cl-a-disabled]="publish_single_po_inflight"
               [class.cl-a-spinner]="publish_single_po_inflight"
               (click)="publish_single_po()">
              Publish
            </a>
          }
          @if (PO_DESTINATIONS[poItem['po_destination']] != null && PO_DESTINATIONS[poItem['po_destination']].publishable && (poItem.publish_process?.state == 'SUCCESS' || publishReports().length > 0)) {
            <a role="button" target="_blank" rel="noopener noreferrer"
               [routerLink]="['/reports', organization()?.id, poItem.po.po_name, poItem.po_item_id]">
              <span class="cl-a-external">Delivery Report</span>
            </a>
          }
          @if ('contentplatform:workflow:Mutation/RestartPoItem' | isAllowed:'contentplatform:po:input.po_name/' + poItem.po.po_name: organization()) {
            <a role="button"
               [class.cl-a-disabled]="restart_single_po_inflight"
               [class.cl-a-spinner]="restart_single_po_inflight"
               (click)="restartWorkflow()">
              Restart
            </a>
          }
        </p>
      </div>
    </section>

    <!-- Publication -->
    @if (poItem.publish_process || publishReports().length > 0) {
      <section class="cl-section cl-section-regular">
        <div class="container cl-spacing-small">
          <div class="card">
            <div class="card-header">
              Publication
              <div class="cl-card-info">
                @if (poItem.publish_process) {
                  @if (poItem.publish_process.state == 'ABORTED') {
                    <span class="cl-badge cl-badge-fixed cl-color-clay">Aborted</span>
                  }
                  @if (poItem.publish_process.state == 'IN_PROGRESS') {
                    <span class="cl-badge cl-badge-fixed cl-color-sky">Publishing ...</span>
                  }
                  @if (poItem.publish_process.state == 'FAILED') {
                    <span class="cl-badge cl-badge-fixed cl-color-berry">Failed</span>
                  }
                  @if (poItem.publish_process.state == 'SUCCESS') {
                    @switch (poItem.po_destination) {
                      @case ("safran-album") {
                        <span class="cl-badge cl-badge-fixed cl-color-petrol">Selected</span>
                      }
                      @default {
                        <span class="cl-badge cl-badge-fixed cl-color-petrol">Published</span>
                      }
                    }
                  }
                }
              </div>
            </div>
            <div class="card-body">
              @if (poItem.publish_process) {
                @if (poItem.publish_process.state == 'FAILED') {
                  <p class="alert cl-alert-error">{{ poItem.publish_process.message }}</p>
                }
                <p>
                  @if (poItem.publish_process.state !== 'IN_PROGRESS') {
                    {{ poItem.publish_process.start_date | duration: poItem.publish_process.end_date }}
                    ({{ poItem.publish_process.start_date | cldate }}
                    &ndash; {{ poItem.publish_process.end_date | cldate }})
                  }
                  @if (poItem.publish_process.state === 'IN_PROGRESS') {
                    Started: {{ poItem.publish_process.start_date | cldate }}
                  }
                  &middot;
                  <app-process-link [processId]="poItem.publish_process.id" [type]="'wf'"></app-process-link>
                </p>
                <p>
                  Destination: {{ poItem.po_destination }}
                  <!-- Only for the 'vod' destination. These URLs address the castlabs-vod origin
                       behind vod{env}.cp.castlabs.com, and only that destination syncs there --
                       every other one writes to its own target, so the link 404s while the item is
                       genuinely published. The workflow being vod_default is not enough: an item can
                       run it and still be published somewhere else entirely. -->
                  @if (poItem.workflow === 'start_workflow_vod_default' && poItem.po_destination === 'vod' && poItem.publish_process.state === 'SUCCESS') {
                    &middot;
                    <a class="cl-a-external"
                       href="https://vod{{envsuffix}}.cp.castlabs.com/{{poItem.customer}}/{{poItem.po.po_name}}/{{poItem.po_item_id}}/dash.mpd">DASH</a>
                    /
                    <a class="cl-a-external"
                       href="https://vod{{envsuffix}}.cp.castlabs.com/{{poItem.customer}}/{{poItem.po.po_name}}/{{poItem.po_item_id}}/hls.m3u8">HLS</a>
                  }
                  @if (PO_DESTINATIONS[poItem['po_destination']] != null && PO_DESTINATIONS[poItem['po_destination']].publishable && poItem.publish_process.state === 'SUCCESS') {
                    &middot;
                    <a class="cl-a" target="_blank" rel="noopener noreferrer"
                       [routerLink]="['/reports', organization()?.id, poItem.po.po_name, poItem.po_item_id]">
                      Delivery Report
                    </a>
                  }
                </p>
              }

              @if (publishReports().length > 0) {
                <table class="cl-table-data" style="width: 100%;">
                  <thead>
                    <tr>
                      <th class="cl-table-head cl-p-tiny">Filename</th>
                      <th class="cl-table-head cl-p-tiny" style="width: 100px;">Size</th>
                      <th class="cl-table-head cl-p-tiny" style="width: 170px;">Delivered</th>
                      <th class="cl-table-head cl-p-tiny" style="width: 120px;">Method</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (report of publishReports(); track $index) {
                      @if ($index === previousDeliveryIndex()) {
                        <tr>
                          <td colspan="4" style="text-align: center; font-style: italic; color: var(--bs-secondary-color);">All files below have been delivered by previous workflows</td>
                        </tr>
                      }
                      <tr>
                        <td>
                          @if (publishedFileUrl(report.filename, $index); as fileUrl) {
                            <a class="cl-a-external" [href]="fileUrl" target="_blank"
                               rel="noopener noreferrer">{{ report.filename }}</a>
                          } @else {
                            {{ report.filename }}
                          }
                        </td>
                        <td class="cl-font-monospace text-end">{{ report.size | fileSize }}</td>
                        <td class="cl-td-time">{{ report.completed_at | cldate }}</td>
                        <td>{{ report.delivery_method }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              }
            </div>
          </div>
        </div>
      </section>
    }

    <!-- Discovery & Encode -->
    <section class="cl-section cl-section-regular">
      <div class="container cl-spacing-small">
        <div class="card">
          <div class="card-header">
            Discovery &amp; Encode
            <div class="cl-card-info">
              @if (poItem.workflow_process.state == 'IN_PROGRESS') {
                @if (!poItem.checkpoint_content_complete && poItem.input_brefix.length > 1) {
                  <span class="cl-badge cl-badge-fixed cl-color-sky">Waiting for files</span>
                }
                @if (!poItem.checkpoint_content_complete && poItem.input_brefix == '/') {
                  <span class="cl-badge cl-badge-fixed cl-color-sky">Resolving Identifier</span>
                }
                @if (poItem.checkpoint_content_complete && !poItem.checkpoint_encodes_done) {
                  <span class="cl-badge cl-badge-fixed cl-color-sky">Encoding ...</span>
                }
                @if (poItem.checkpoint_content_complete && poItem.checkpoint_encodes_done) {
                  <span class="cl-badge cl-badge-fixed cl-color-sky">Encodes Done</span>
                }
              }
              @if (poItem.workflow_process.state == 'FAILED') {
                <span class="cl-badge cl-badge-fixed cl-color-berry">Failed</span>
              }
              @if (poItem.workflow_process.state == 'SUCCESS') {
                <span class="cl-badge cl-badge-fixed cl-color-petrol">Encoded</span>
              }
              @if (poItem.workflow_process.state == 'ABORTED') {
                <span class="cl-badge cl-badge-fixed cl-color-clay">Aborted</span>
              }
            </div>
          </div>
          <div class="card-body">
            @if (poItem.workflow_process.state == 'FAILED') {
              <p class="alert cl-alert-error">{{ poItem.workflow_process.message }}</p>
            }
            <p>
              @if (poItem.workflow_process.state !== 'IN_PROGRESS') {
                {{ poItem.workflow_process.start_date | duration: poItem.workflow_process.end_date }}
                ({{ poItem.workflow_process.start_date | cldate }}
                &ndash; {{ poItem.workflow_process.end_date | cldate }})
              }
              @if (poItem.workflow_process.state === 'IN_PROGRESS') {
                Started: {{ poItem.workflow_process.start_date | cldate }}
              }
              &middot;
              <app-process-link [processId]="poItem.workflow_process.id" [type]="'wf'"></app-process-link>
              @if (staff()) {
                &middot;
                <a rel="noopener noreferrer" class="cl-a-external"
                   [href]="'https://us-east-1.console.aws.amazon.com/dynamodbv2/home?region=us-east-1#edit-item?itemMode=2&pk=' + poItem.po.po_name + '&route=ROUTE_ITEM_EXPLORER&sk=' + poItem.po_item_id + '&table=' + tablename">Workflow DB Item</a>
              }
            </p>

            <!-- Produced Files -->
            @if (encodeFiles().length > 0) {
              <h4>Produced Files
                <app-s3-link [fof]="'s3://' + poItem.output_brefix"></app-s3-link>
                @if (poItem.preview && (poItem.preview.dash_manifest_url || poItem.preview.hls_manifest_url)) {
                  &middot;
                  <a class="cl-a"
                     [routerLink]="['/o', organization().id, 'workflows', poItem.po.po_name.split('_')[0], poItem.po.po_name, poItem.po_item_id, 'preview']"
                     role="link">Preview</a>
                }
              </h4>
              <table style="width: 100%;" class="cl-table-data">
                <thead>
                  <tr>
                    <th class="cl-table-head cl-p-tiny">Filename</th>
                    <th class="cl-table-head cl-p-tiny" style="width: 120px;">Size</th>
                    <th class="cl-table-head cl-p-tiny" style="width: 170px;">Last Modified</th>
                    <th class="cl-table-head cl-p-tiny" style="width: 1%;"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (file of encodeFiles(); track file.id) {
                    <tr [class.cl-tr-inflight]="renameInflight() === file.id || deleteInflight() === file.id">
                      <td class="cl-form">
                        @if (editingId === file.id) {
                          <input type="text" class="form-control form-control-sm"
                                 [(ngModel)]="editingName"
                                 [disabled]="renameInflight() === file.id"
                                 (keyup.enter)="saveRename(file)"
                                 (keyup.escape)="cancelRename()" />
                        } @else if (renameInflight() === file.id || deleteInflight() === file.id) {
                          <span><i class="fas fa-spinner fa-spin"></i> {{ file.name }}</span>
                        } @else {
                          <span [class.cl-animation-flash-text]="copiedFileId() === file.id">{{ file.name }}</span>
                        }
                      </td>
                      <td class="cl-font-monospace text-end">{{ file.size | fileSize }}</td>
                      <td class="cl-td-time">{{ file.last_modified | cldate }}</td>
                      <td class="cl-td-links" style="width: 1%;">
                        @if (editingId === file.id) {
                          <a class="cl-a-btn cl-a-primary" role="button"
                             [class.cl-a-disabled]="renameInflight() === file.id"
                             [class.cl-a-spinner]="renameInflight() === file.id"
                             (click)="saveRename(file)">Save</a>
                          <a class="cl-a-btn" role="button"
                             [class.cl-a-disabled]="renameInflight() === file.id"
                             (click)="cancelRename()">Cancel</a>
                        } @else if (deleteConfirmId === file.id) {
                          <span class="cl-text-danger">Delete?</span>
                          <a class="cl-a-btn cl-a-danger" role="button" (click)="deleteFile(file)">Confirm</a>
                          <a class="cl-a-btn" role="button" (click)="cancelDelete()">Cancel</a>
                        } @else {
                          @if (canDownload(file)) {
                            <a class="cl-a-btn cl-a-primary" role="button" (click)="downloadFile(file)">Download</a>
                          }
                          @if (canRename(file)) {
                            <a class="cl-a-btn" role="button" (click)="startRename(file)">Rename</a>
                          }
                          <a class="cl-a-btn cl-a-primary" role="button" (click)="copyS3Path(file)">
                            Copy S3 path
                          </a>
                          <a class="cl-a-btn" role="button" (click)="confirmDelete(file)">Delete</a>
                          @if (canShowTsaLog(file)) {
                            <a class="cl-a-btn" role="button" (click)="openTsaLog(file)">TS Log</a>
                          }
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            }

            <!-- Encoding Jobs -->
            @if (poItem.vtk_jobs.length > 0) {
              <h4>Encoding Jobs</h4>
              <table class="cl-table-data" style="width: 100%;">
                <thead>
                  <tr>
                    <th class="cl-table-head cl-p-tiny">ID</th>
                    <th class="cl-table-head cl-p-tiny">Status</th>
                    <th class="cl-table-head cl-p-tiny" style="width: 170px;">Created</th>
                    <th class="cl-table-head cl-p-tiny" style="width: 170px;">Modified</th>
                    <th class="cl-table-head cl-p-tiny" style="width: 220px;"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (vtk_job of poItem.vtk_jobs; track vtk_job.id) {
                    <tr>
                      <td class="cl-cursor-pointer cl-td-id" [appTooltip]="`${vtk_job.id}\nclick-to-copy!`" tooltipPlacement="end" tooltipColor="light" (click)="copyVtkJobId(vtk_job.id)">
                        @if (vtk_job.id) {
                          <span [class.cl-animation-flash-text]="copiedVtkJobId() === vtk_job.id">{{ vtk_job.id }}</span>
                        }
                      </td>
                      <td class="cl-cursor-pointer" (click)="goToVtkJob(poItem, vtk_job)">{{ vtk_job.status_text }}</td>
                      <td class="cl-cursor-pointer cl-td-time" (click)="goToVtkJob(poItem, vtk_job)">{{ vtk_job.created | cldate }}</td>
                      <td class="cl-cursor-pointer cl-td-time" (click)="goToVtkJob(poItem, vtk_job)">{{ vtk_job.modified | cldate }}</td>
                      <td class="cl-td-links">
                        <a class="cl-a-btn cl-a-primary" [routerLink]="['/o', organization()?.id, 'workflows', poItem.po!.airline, poItem.po!.po_name, poItem.po_item_id, 'vtk-jobs', vtk_job.id]"
                             [queryParams]="{org_urn: vtk_job.organization_urn}"
                             appTooltip="View job details within the portal" tooltipPlacement="top" tooltipColor="light">View</a>
                        <a class="cl-a-btn cl-a-primary cl-a-external cl-p-small" target="_blank" rel="noopener noreferrer"
                           href="{{ VTK_SERVER }}/#/o/{{ vtk_job.organization_urn }}/jobs/{{ vtk_job.id }}?as={{ organization()?.id }}">Open in VTK</a>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            }

            <!-- Input Files -->
            @if (poItem.checkpoint_content_uploaded || poItem.tracks.length > 0) {
              <h4>Input Files
                <app-s3-link [fof]="'s3://' + poItem.input_brefix"></app-s3-link>
                &middot;
                <a class="cl-a" [routerLink]="'/o/' + organization().id + '/files/browse/' + poItem.input_brefix">Go to source folder</a>
              </h4>
              @if (poItem.tracks.length > 0) {
                <table class="cl-table-data" style="width: 100%;">
                  <thead>
                    <tr>
                      <th class="cl-table-head cl-p-tiny">Requested</th>
                      <th class="cl-table-head cl-p-tiny">Selected</th>
                      <th class="cl-table-head cl-p-tiny">Messages</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (element of poItem.tracks; track $index) {
                      <tr>
                        <td style="white-space: nowrap">{{ element.codec_type }} {{ element.lang }}</td>
                        <td>
                          @if (element.source) {
                            <dt>
                              <a class="cl-a" [routerLink]="'/o/' + organization().id + '/files/details/' + poItem.input_brefix + element.source.key">{{ element.source.key }}</a>
                            </dt>
                            @if (element.source.coded_width) {
                              <dd>Resolution: {{ element.source.coded_width }}x{{ element.source.coded_height }}</dd>
                            }
                            @if (element.source.language) {
                              <dd>Language (BCP-47): {{ element.source.language }}</dd>
                            }
                            @if (element.source.codec_type) {
                              <dd>Type: {{ element.source.codec_type }}</dd>
                            }
                          }
                        </td>
                        <td>
                          <ul>
                            @for (msg of element.messages; track msg) {
                              <li style="white-space: break-spaces;">
                                @if (msg.toLowerCase().includes('restor')) {
                                  <span class="alert cl-alert-info">{{ msg }}</span>
                                } @else {
                                  {{ msg }}
                                }
                              </li>
                            }
                          </ul>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              } @else {
                <p><span class="alert cl-alert-warning">No files available in source directory</span></p>
              }
            }
          </div>
        </div>
      </div>
    </section>

    <!-- Workflow Parameters -->
    <section class="cl-section cl-section-regular">
      <div class="container cl-spacing-small">
        <div class="card">
          <div class="card-header">
            Workflow Parameters
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <dl>
                  <dt>Workflow type / Template / Filename</dt>
                  <dd>{{ poItem.workflow.substring(15) }} / {{ poItem.vtk_template }} / {{ poItem.filename }}</dd>

                  @if (hasVideoTrack()) {
                    <dt>Aspect Ratio</dt>
                    <dd>
                      @switch (poItem.aspect_ratio) {
                        @case ('4x3') {
                          4:3 (forced)
                        }
                        @case ('16x9') {
                          16:9 (forced)
                        }
                        @default {
                          pass through
                        }
                      }
                    </dd>
                  }

                  @if (poItem.po_destination) {
                    <dt>PO Destination</dt>
                    <dd>{{ poItem.po_destination }}</dd>
                  }

                  @if (poItem.metadata_source) {
                    <dt>Metadata Source</dt>
                    <dd>{{ poItem.metadata_source }}</dd>
                  }

                  @if (poItem.wrap_up_workflow) {
                    <dt>Wrap Up Workflow</dt>
                    <dd>{{ poItem.wrap_up_workflow }}</dd>
                  }
                </dl>
              </div>

              <div class="col-md-6">
                <dl>
                  @if (poItem.email_notification?.length) {
                    <dt>Email Notification</dt>
                    <dd>{{ poItem.email_notification.join(', ') }}</dd>
                  }

                  @if (poItem.email_notification_publish?.length) {
                    <dt>Publish Notification Email</dt>
                    <dd>{{ poItem.email_notification_publish.join(', ') }}</dd>
                  }
                </dl>
              </div>
            </div>
            @if (poItem.content_identifier) {
              <h4>Content Identifier</h4>
              <div class="pre-container">
                <pre>{{ poItem.content_identifier }}</pre>
                <app-do-button class="pre-copy-btn"
                  [messageField]="content_identifier_message"
                  (actionTriggered)="copyToClipboard($event, poItem.content_identifier)" buttonClass="btn cl-btn-icon cl-color-tertiary it-cancel">
                  <i class="fas fa-copy"></i>
                </app-do-button>
              </div>
              <app-message-field #content_identifier_message/>
            }
            @if (poItem.format_specific_data_json) {
              <h4>Format Specific Data</h4>
              <div class="pre-container">
                <pre>{{ poItem.format_specific_data_json | json }}</pre>
                <app-do-button class="pre-copy-btn"
                  [messageField]="format_specific_data_message"
                  (actionTriggered)="copyToClipboard($event, poItem.format_specific_data_json)" buttonClass="btn cl-btn-icon cl-color-tertiary it-cancel">
                  <i class="fas fa-copy"></i>
                </app-do-button>
              </div>
              <app-message-field #format_specific_data_message/>
            }
          </div>
        </div>
      </div>
    </section>

  }
</main>
